export default {
  buttons: {
    save: 'Save',
  },
  error_messages: {
    product_unavailable: 'Sold out!',
  },
};
